export default "__VITE_ASSET__Fak2EPFS__"